// Vorsicht: Zyklische Referenz, es gibt aber keine bessere Lösung bei dieser Strukturierung des Codes:
// eslint-disable-next-line
import { store } from '@user/store';

export class UserError extends Error {
  constructor(error, lang) {
    super(error);
    this.title = error.name;
    if (this.title === 'ChunkLoadError') {
      this.title = 'Netzwerk-Fehler';
      this.message = codeMap.ChunkLoadError[lang];
    }
    this.code = error.code || 'E01';
    if (error.config) {
      // http error
      if (!error.response || !error.response.data) {
        if (error.message === 'Network Error') {
          if (error.config.url.indexOf('trackPicatNavigation')) {
            // Vermeide Fehleranzeige bei Netzwerkproblemen wenn Picat läuft
            this.code = '';
          } else {
            // Netzwerkfehler
            this.code = 'API02';
          }
        } else {
          this.code = 'C01';
        }
      } else if (
        error.config.url.indexOf('refreshToken') !== -1 ||
        error.response.status === 419
      ) {
        if (
          store.state.userData.userName &&
          store.state.userData.userName.includes('self_register_anon')
        ) {
          // Token-Fehler in self_register Lauf -> neu registrieren
          this.code = 'C22';
          this.btnLink = `/registration?profileId=${store.state.profiles[0].id}`;
        } else {
          this.code = 'C02';
        }
        // Sondermeldung BMW Initiativ-Mailadresse existiert
      } else if (
        error.response.status === 403 &&
        (error.response.data.data === 'C12' ||
          error.response.data.error === 'C12')
      ) {
        this.code = 'C12';
      } else if (error.response.status === 401) {
        if (
          store.state.userData.userName &&
          store.state.userData.userName.includes('self_register_anon')
        ) {
          // Berechtigungs-Fehler in self_register Lauf -> neu registrieren
          this.code = 'C23';
          this.btnLink = `/registration?profileId=${store.state.profiles[0].id}`;
        } else {
          // Berechtigungs-Fehler -> neu ammelden
          this.code = 'C03';
        }
        this.disableClose = true;
      } else if (error.response.status === 403) {
        // Anfrage ist nicht erlaubt -> Aufforderung zur Wiederholung
        if (
          error.response.data.data === 'C10' ||
          error.response.data.error === 'C10'
        ) {
          // Passwortvalidierung fehlgeschlagen
          this.code = 'C10';
        } else if (
          error.response.data.data === 'C11' ||
          error.response.data.error === 'C11'
        ) {
          // Falscher Benutzername
          this.code = 'C11';
        } else if (
          error.response.data.data === 'C13' ||
          error.response.data.error === 'C13'
        ) {
          // Altes Paswort nicht korrekt
          this.code = 'C13';
        } else if (
          error.response.data.data === 'C05' ||
          error.response.data.error === 'C05'
        ) {
          // Falscher Benutzername
          this.code = 'C05';
        } else {
          // alle anderen Fehler
          this.code = 'C05';
        }
      } else if (error.response.status === 409) {
        // Konflikt bei Ausführung der Anfrage
        this.code =
          error.config.url.indexOf('saveNewPassword') !== -1 ||
          error.config.url.indexOf('changeUserPassword') !== -1
            ? 'C04'
            : 'API01';
      } else if (
        error.response.data.data === 'C06' ||
        error.response.data.errorMsg === 'C06'
      ) {
        // User nicht gefunden in ConfigController (during getPasswordRequirementsByUserHash)
        this.code = 'C06';
        this.disableClose = true;
      } else if (
        error.response.data.data === 'C07' ||
        error.response.data.errorMsg === 'C07'
      ) {
        // User und Project passen nicht zusammen in ConfigController (during getPasswordRequirementsByUserHash)
        this.code = 'C07';
        this.disableClose = true;
      } else if (error.response.status === 402) {
        // Zugang nicht aktiviert
        this.code = 'C14';
        this.disableClose = true;
      } else {
        this.code = 'API01';
      }
    }
    this.message = codeMap[this.code].message[lang];
    this.title = codeMap[this.code].title[lang];
    this.disableClose = codeMap[this.code].disableClose;
    this.showBtn = codeMap[this.code].showBtn;
    this.btnLink = this.btnLink ? this.btnLink : codeMap[this.code].btnLink;
    this.btnText = codeMap[this.code].btnText
      ? codeMap[this.code].btnText[lang]
      : '';
  }
}

const codeMap = {
  ChunkLoadError: {
    'de-DU':
      'Die Verbindung zum Server wurde unterbrochen, bitte überprüfe deine Internetverbindung.',
    de:
      'Die Verbindung zum Server wurde unterbrochen. Bitte überprüfen Sie Ihre Internetverbindung.',
    en_GB:
      'The connection to the server has been lost. Please check your Internet connection.',
    hu: 'Megszakadt a kapcsolat a szerverrel. Ellenőrizze internetkapcsolatát.',
  },
  E01: {
    title: {
      'de-DU': 'Unbekannter Fehler',
      de: 'Unbekannter Fehler',
      en_GB: 'Unknown error',
      hu: 'Ismeretlen hiba',
    },
    message: {
      'de-DU':
        'Während der Bearbeitung deiner Eingaben ist ein Fehler aufgetreten. Bitte prüfe deine Eingaben und versuche es erneut.',
      de:
        'Während der Bearbeitung Ihrer Eingaben ist ein Fehler aufgetreten. Bitte prüfen Sie Ihre Eingaben und versuchen Sie es erneut.',
      en_GB:
        'An error occurred while processing your entries. Please check your entries and try again.',
      hu:
        'Bejegyzésének feldolgozása során hiba lépett fel. Ellenőrizze bejegyzését és próbálja meg újra.',
    },
  },
  E02: {
    title: {
      'de-DU': 'URL Error',
      de: 'URL Error',
      en_GB: 'URL Error',
      hu: 'URL Error',
    },
    message: {
      'de-DU': 'Der verwendete Link ist ungültig.',
      de: 'Der verwendete Link ist ungültig.',
      en_GB: 'The link you used is invalid.',
      hu: 'A használt link érvénytelen.',
    },
    showBtn: false,
    disableClose: true,
  },
  C01: {
    comment: 'Unbekannter Client-Fehler',
    title: {
      'de-DU': 'Unbekannter Client-Fehler',
      de: 'Unbekannter Client-Fehler',
      en_GB: 'Unknown client error',
      hu: 'Ismeretlen ügyfélhiba',
    },
    message: {
      'de-DU':
        'Dein Browser hat Probleme, das Verfahren darzustellen. Bei andauernden Darstellungsfehlern wechsele den Browser.',
      de:
        'Ihr Browser hat Probleme, das Verfahren darzustellen. Bei andauernden Darstellungsfehlern wechseln Sie den Browser.',
      en_GB:
        'Your browser is having problems displaying the assessment. If these problems persist, please choose a different browser.',
      hu:
        'A böngészőnek problémái vannak az eljárás megjelenítésével. Ha a megjelenítési hibák továbbra is fennállnak, váltson böngészőt.',
    },
  },
  C02: {
    comment: 'Session abgelaufen. (HTTP-419)',
    title: {
      de: 'Deine Sitzung ist abgelaufen',
      'de-DU': 'Ihre Sitzung ist abgelaufen',
      en_GB: 'Your session has expired',
      hu: 'A munkamenet lejárt.',
    },
    message: {
      'de-DU': 'Bitte melde Dich erneut an.',
      de: 'Bitte melden Sie sich erneut an.',
      en_GB: 'Please log in again.',
      hu: 'Kérjük, jelentkezzen be újra.',
    },
    showBtn: true,
    disableClose: true,
    btnLink: '/login',
    btnText: {
      'de-DU': 'Neu anmelden',
      de: 'Neu anmelden',
      en_GB: 'Go to Login',
      hu: 'Jelentkezzen be újra',
    },
  },
  C22: {
    comment: 'Session abgelaufen. (HTTP-419)',
    title: {
      'de-DU': 'Deine Sitzung ist abgelaufen',
      de: 'Ihre Sitzung ist abgelaufen',
      en_GB: 'Your session has expired',
      hu: 'A munkamenet lejárt.',
    },
    message: {
      de: 'Bitte registrieren Sie sich erneut',
      'de-DU': 'Bitte registriere dich erneut',
      en_GB: 'Please register again',
      hu: 'Kérjük, regisztráljon újra',
    },
    showBtn: true,
    disableClose: true,
    btnText: {
      'de-DU': 'Neu registrieren',
      de: 'Neu registrieren',
      en_GB: 'Go to Register',
      hu: 'Menj a regisztrációhoz',
    },
  },
  C03: {
    comment: 'Session abgelaufen. (HTTP-401)',
    title: {
      'de-DU': 'Deine Sitzung ist abgelaufen',
      de: 'Ihre Sitzung ist abgelaufen',
      en_GB: 'Your session has expired',
      hu: 'A munkamenet lejárt.',
    },
    message: {
      'de-DU': 'Bitte melde Dich erneut an.',
      de: 'Bitte melden Sie sich erneut an.',
      en_GB: 'Please log in again.',
      hu: 'Kérjük, jelentkezzen be újra.',
    },
    showBtn: true,
    disableClose: true,
    btnLink: '/login',
    btnText: {
      'de-DU': 'Neu anmelden',
      de: 'Neu anmelden',
      en_GB: 'Go to Login',
      hu: 'Jelentkezzen be újra',
    },
  },
  C23: {
    comment: 'Session abgelaufen. (HTTP-401)',
    title: {
      'de-DU': 'Deine Sitzung ist abgelaufen',
      de: 'Ihre Sitzung ist abgelaufen',
      en_GB: 'Your session has expired',
      hu: 'A munkamenet lejárt.',
    },
    message: {
      de: 'Bitte registrieren Sie sich erneut',
      'de-DU': 'Bitte registriere dich erneut',
      en_GB: 'Please register again',
      hu: 'Kérjük, regisztráljon újra',
    },
    showBtn: true,
    disableClose: true,
    btnText: {
      'de-DU': 'Neu registrieren',
      de: 'Neu registrieren',
      en_GB: 'Go to Registration',
      hu: 'Menj a regisztrációhoz',
    },
  },
  C04: {
    comment: 'Conflict. (HTTP-409)',
    title: {
      'de-DU': 'Passwort wurde bereits verwendet',
      de: 'Passwort wurde bereits verwendet',
      en_GB: 'Password used before',
      hu: 'A jelszót már használták',
    },
    message: {
      de:
        'Das neue Passwort wurde schon einmal verwendet. Bitte benutzen Sie ein anderes Passwort!',
      'de-DU':
        'Das neue Passwort wurde schon einmal verwendet. Bitte benutze ein anderes Passwort!',
      en_GB:
        'The new password has been used before. Please use a different password.',
      hu:
        'Az új jelszót már korábban is használták. Kérjük, használjon másik jelszót.',
    },
    showBtn: true,
    btnText: {
      'de-DU': 'Wiederholen',
      de: 'Wiederholen',
      en_GB: 'Retry',
      hu: 'Ismétlés',
    },
  },
  C05: {
    comment: 'Forbidden. (HTTP-403)',
    title: {
      'de-DU': 'Keine Berechtigung',
      de: 'Keine Berechtigung',
      en_GB: 'No authorisation',
      hu: 'Nincs engedély',
    },
    message: {
      'de-DU': '',
      de: '',
      en_GB: '',
      hu: '',
    },
    showBtn: true,
    btnText: {
      'de-DU': 'Wiederholen',
      de: 'Wiederholen',
      en_GB: 'Retry',
      hu: 'Ismétlés',
    },
  },
  C06: {
    comment: 'Invalid User Hash',
    title: {
      'de-DU': 'Link abgelaufen',
      de: 'Link abgelaufen',
      en_GB: 'Expired Link',
      hu: 'A link lejárt',
    },
    message: {
      'de-DU':
        'Der verwendete Link ist abgelaufen. Bitte nutze den Link aus der neusten Mail oder fordere einen neuen Link an.',
      de:
        'Der verwendete Link ist abgelaufen. Bitte nutzen Sie den Link aus der neusten Mail oder fordern Sie einen neuen Link an.',
      en_GB:
        'The link you used has expired. Please use the link from the latest e-mail or request a new link.',
      hu:
        'A használt link lejárt. Kérjük, használja a legutóbbi e-mailben található hivatkozást, vagy kérjen új linket.',
    },
    showBtn: false,
    disableClose: true,

    btnText: {
      'de-DU': '',
      de: '',
      en_GB: '',
      hu: '',
    },
  },
  C07: {
    comment: 'project and user not mapped',
    title: {
      'de-DU': 'Link abgelaufen',
      de: 'Link abgelaufen',
      en_GB: 'Expired Link',
      hu: 'A link lejárt',
    },
    message: {
      'de-DU':
        'Der verwendete Link ist abgelaufen. Bitte nutze den Link aus der neusten Mail oder fordere einen neuen Link an.',
      de:
        'Der verwendete Link ist abgelaufen. Bitte nutzen Sie den Link aus der neusten Mail oder fordern Sie einen neuen Link an.',
      en_GB:
        'The link you used has expired. Please use the link from the latest e-mail or request a new link.',
      hu:
        'A használt link lejárt. Kérjük, használja a legutóbbi e-mailben található hivatkozást, vagy kérjen új linket.',
    },
    showBtn: false,
    disableClose: true,

    btnText: {
      'de-DU': '',
      de: '',
      en_GB: '',
      hu: '',
    },
  },
  C10: {
    comment: 'Password invalid. (HTTP-403)',
    title: {
      'de-DU': 'Passwort nicht gespeichert',
      de: 'Passwort nicht gespeichert',
      en_GB: 'Password not saved',
      hu: 'A jelszó nincs mentve',
    },
    message: {
      'de-DU':
        'Bitte achte darauf, dass dein Passwort den Vorgaben entspricht.',
      de: 'Bitte achten Sie darauf, dass Ihr Passwort den Vorgaben entspricht.',
      en_GB: 'Please ensure that your password meets the requirements.',
      hu:
        'Kérjük, győződjön meg róla, hogy jelszava megfelel-e a követelményeknek.',
    },
    showBtn: true,
    btnText: {
      'de-DU': 'Wiederholen',
      de: 'Wiederholen',
      en_GB: 'Retry',
      hu: 'Újra',
    },
  },
  C11: {
    comment: 'Password invalid. (HTTP-403)',
    title: {
      'de-DU': 'Registrierung ist nicht erfolgt',
      de: 'Registrierung ist nicht erfolgt',
      en_GB: 'Registration has not been completed',
      hu: 'Registration has not been completed',
    },
    message: {
      'de-DU':
        'Bitte achte darauf, dass dein Passwort den Vorgaben entspricht.',
      de: 'Bitte achten Sie darauf, dass Ihr Passwort den Vorgaben entspricht.',
      en_GB: 'Please ensure that your password meets the requirements.',
      hu:
        'Kérjük, győződjön meg róla, hogy jelszava megfelel-e a követelményeknek.',
    },
    showBtn: true,
    btnText: {
      'de-DU': 'Wiederholen',
      de: 'Wiederholen',
      en_GB: 'Retry',
      hu: 'Újra',
    },
  },
  C12: {
    comment: 'user already registered',
    title: {
      'de-DU': 'Registrierung ist nicht erfolgt',
      de: 'Registrierung ist nicht erfolgt',
      en_GB: 'Registration has not been completed',
      hu: 'Registration has not been completed',
    },
    message: {
      'de-DU': 'Ihre Mail-Adresse ist bereits für dieses Projekt registriert.',
      de: 'Ihre Mail-Adresse ist bereits für dieses Projekt registriert.',
      en_GB: 'Your mail address is already registered for this project.',
      hu: 'Your mail address is already registered for this project.',
    },
    showBtn: true,
    btnText: {
      'de-DU': 'Wiederholen',
      de: 'Wiederholen',
      en_GB: 'Retry',
      hu: 'Újra',
    },
  },
  C13: {
    comment: 'Altes Passwort inkorrekt',
    title: {
      'de-DU': 'Passwort nicht gespeichert',
      de: 'Passwort nicht gespeichert',
      en_GB: 'Password not saved',
      hu: 'A jelszó nincs mentve',
    },
    message: {
      'de-DU': 'Bisheriges Passwort inkorrekt',
      de: 'Bisheriges Passwort inkorrekt',
      en_GB: 'Previous password not correct',
      hu: 'Previous password not correct',
    },
    showBtn: true,
    btnText: {
      'de-DU': 'Wiederholen',
      de: 'Wiederholen',
      en_GB: 'Retry',
      hu: 'Újra',
    },
  },
  C14: {
    comment: 'project and user not mapped',
    title: {
      'de-DU': 'Zugang nicht aktiviert',
      de: 'Zugang nicht aktiviert',
      en_GB: 'Account not activated',
      hu: 'Account not activated',
    },
    message: {
      'de-DU':
        'Der Zugang ist noch nicht aktiviert. Bitte aktiviere den Account, bevor du dich anmeldest.',
      de:
        'Der Zugang ist noch nicht aktiviert. Bitte aktiviere den Account, bevor du dich anmeldest.',
      en_GB:
        'Account is not activated. Please activate the account before logging in.',
      hu:
        'Account is not activated. Please activate the account before logging in.',
    },
    showBtn: false,
    disableClose: true,

    btnText: {
      'de-DU': '',
      de: '',
      en_GB: '',
      hu: '',
    },
  },
  API01: {
    title: {
      'de-DU': 'Unbekannter Anfrage-Fehler',
      de: 'Unbekannter Anfrage-Fehler',
      en_GB: 'Unknown request error',
      hu: 'Ismeretlen kérési hiba',
    },
    message: {
      'de-DU':
        'Deine Anfrage konnte nicht verarbeitet werden. Folge dem Link aus der Einladungsmail und logge dich erneut ein.',
      de:
        'Ihre Anfrage konnte nicht verarbeitet werden. Folgen Sie dem Link aus der Einladungsmail und loggen Sie sich erneut ein.',
      en_GB:
        'Your request could not be processed. Please select the link in the invitation email and log in again.',
      hu:
        'Kérését nem tudtuk feldolgozni. Kövesse a meghívó e-mailben található linket, és jelentkezzen be.',
    },
    showBtn: true,
    btnLink: '/login',
    btnText: {
      'de-DU': 'Neu anmelden',
      de: 'Neu anmelden',
      en_GB: 'Go to Login',
    },
  },

  API02: {
    title: {
      'de-DU': 'Anfrage-Fehler: Netzwerkproblem',
      de: 'Anfrage-Fehler: Netzwerkproblem',
      en_GB: 'Request error: network problem',
      hu: 'Kérési hiba: Hálózati probléma',
    },
    message: {
      'de-DU':
        'Deine Anfrage konnte nicht verarbeitet werden. Bitte überprüfe deine Internetverbindung und versuche es noch einmal.',
      de:
        'Ihre Anfrage konnte nicht verarbeitet werden. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es noch einmal.',
      en_GB:
        'Your request could not be processed. Please check your Internet connection and try again.',
      hu:
        'Kérését nem tudtuk feldolgozni. Ellenőrizze internetkapcsolatát és próbálja meg még egyszer.',
    },
  },

  DP01: {
    title: {
      'de-DU': 'Anfrage-Fehler: Datenschutzerklärung',
      de: 'Anfrage-Fehler: Datenschutzerklärung',
      en_GB: 'request error: data protection statement',
      hu: 'request error: data protection statement',
    },
    message: {
      de:
        'Die Datenschutzerklärung konnte nicht geladen werden. Kontrollieren Sie Ihre Internetverbindung, versuchen Sie es erneut oder wenden Sie sich an support@eligo.de.',
      'de-DU':
        'Die Datenschutzerklärung konnte nicht geladen werden. Kontrolliere deine Internetverbindung, versuche es erneut oder wende dich an support@eligo.de.',
      en_GB:
        'The data protection statement could not be fetched from our server. Check your connection, try again or contact support@eligo.de.',
      hu:
        'The data protection statement could not be fetched from our server. Check your connection, try again or contact support@eligo.de.',
    },
  },
};
